import { useEffect, useMemo, useState } from "react";
import useLenis from "@/hooks/useLenis";
import { getProducts, getSettings } from "@/lib/api";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Products from "@/components/site/Products";
import OrderSection from "@/components/site/OrderSection";
import About from "@/components/site/About";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  const [products, setProducts] = useState([]);
  const [cashtag, setCashtag] = useState("");
  const [quantities, setQuantities] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([getProducts(), getSettings()])
      .then(([prods, settings]) => {
        setProducts(prods);
        setCashtag(settings.cashtag);
        setQuantities(Object.fromEntries(prods.map((p) => [p.id, 0])));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const setQty = (id, value) => setQuantities((q) => ({ ...q, [id]: value }));
  const cartCount = useMemo(() => Object.values(quantities).reduce((a, b) => a + b, 0), [quantities]);

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center bg-cream">
        <img src="/assets/logo-cut.png" alt="ZoJu Juices" className="h-20 w-auto animate-pulse" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream">
      <Nav cartCount={cartCount} />
      <Hero />
      <Marquee />
      <Products products={products} quantities={quantities} setQty={setQty} />
      <OrderSection products={products} quantities={quantities} setQty={setQty} cashtag={cashtag} />
      <About />
      <Footer />
    </div>
  );
}
